/**
 * Bounded in-memory event log (009). `debugLog()` is a no-op when debug is
 * disabled, so host code can call it unconditionally with zero cost in prod.
 */
import { isDebugEnabled } from './flag.js'

export interface LogEntry {
  tMs: number
  event: string
  data?: Record<string, unknown> | undefined
}

const MAX_ENTRIES = 500
const buffer: LogEntry[] = []
const startMs = Date.now()

export function debugLog(event: string, data?: Record<string, unknown>): void {
  if (!isDebugEnabled()) return
  buffer.push({ tMs: Date.now() - startMs, event, data })
  if (buffer.length > MAX_ENTRIES) buffer.splice(0, buffer.length - MAX_ENTRIES)
}

/** A copy of the recent log entries (oldest → newest). */
export function recentLog(): LogEntry[] {
  return buffer.slice()
}
